import timeZones from '@/constants/timeZones';
import ITimeZone from '@/types/ITimeZone';
import { Select } from 'chakra-react-select';

type ITimeZoneSelectProps = Omit<React.ComponentProps<typeof Select>, 'onChange' | 'value'> & {
	onChange: (value: ITimeZone) => void;
	value: ITimeZone;
};

export default function TimeZoneSelector(props: ITimeZoneSelectProps) {
	return (
		<Select
			{...props}
			value={{ label: props.value, value: props.value }}
			options={timeZones.map((tz) => ({ label: tz, value: tz }))}
			onChange={(v: any) => {
				if (!v?.value) {
					return;
				}
				props.onChange(v.value);
			}}
			isDisabled={props.isDisabled}
		/>
	);
}
